var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3"},[(_vm.label)?_c('div',{staticClass:"caption mb-1"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('compact',{style:(_vm.style),attrs:{"value":_vm.value},on:{"input":function($event){_vm.onInput($event.hex)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }